import { Menu, Select } from 'antd';
import styled from 'styled-components';
import { Theme } from 'utils/color/horizonTheme';

export const StyledMenu = styled(Menu)`
  background-color: ${({ theme }) =>
    theme.themeName === Theme.Dark
      ? theme.tertiaryBackgroundColor
      : theme.secondaryBackgroundColor};
  color: ${({ theme }) => theme.headerColor};

  .ant-menu-submenu-arrow {
    color: ${({ theme }) => theme.headerColor};
  }
`;

export const StyledSelect = styled(Select)`
  width: auto;
  min-width: 200px;
`;
